import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Form } from "react-bootstrap";
export default function FormFeedback(props) {
    const messages = props.field?.errors?.map(_ => _.message);
    if (messages === undefined) {
        return _jsx(Fragment, {});
    }
    return _jsx(Form.Control.Feedback, { type: "invalid", children: messages.map(error => _jsxs(Fragment, { children: [error, ".", _jsx("br", {})] }, error)) });
}
